module.exports = {
  base: 16,
  themeColor: '#ffffff',
  colors: {
    black: '#000000',
    white: '#ffffff',
    yellow: '#f7d775',
    grey: '#797676',
    greyaccessible:  '#949494'
  },
  colorsRGB: {
    black: '0, 0, 0',
    white: '255, 255, 255',
    yellow: '247, 215, 117',
    grey: '121, 118, 118',
  },
  aspectRatios: [
    [1, 1],
    [3, 2],
    [4, 3],
    [6, 5],
    [9, 13],
    [9, 16],
    [16, 9],
    [5, 3]
  ],
  spacingBase: 8,
  spacings: {
    0: 0,
    '05': 0.5,
    1: 1,
    // '1.5': 1.5, // would be good to have
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    12: 12,
    16: 16,
    20: 20,
  },
  font: {
    family: {
      serif: "'Loreal', sans-serif",
    },
    size: {
      default: '16px',
      '3xl': '64px',
      '2xl': '48px',
      xl: '36px',
      l: '32px',
      m: '24px',
      s: '20px',
      xs: '16px',
      '2xs': '12px',
      '3xs': '10px',
    },
    weight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      default: 1.25,
      '2xs': 0.875,
      xs: 1,
      s: 1.125,
      m: 1.25,
      l: 1.375,
      xl: 1.5,
    },
  },
  screens: {
    '3xs': '20rem', // 320px
    '2xs': '23.4375rem', // 375px
    xs: '26.5625rem', // 425px
    s: '48rem', // 768px
    m: '60rem', // 960px
    l: '64rem', // 1024px
    'l+': '80rem', //1280px
    xl: '90rem', // 1440px
    '2xl': '120rem', // 1920px
    '3xl': '160rem', // 2560px
  },
  zindex: {
    negativeZIndex1: -1,
    stickyBar: 98,
    header: 99,
    popup: 999,
    nav: 1000,
    modal: 1500,
    skip: 2000,
  },
};
